import { Check } from "lucide-react";

export function BlogChecklist({ items }: { items: string[] }) {
  if (!items || items.length === 0) return null;
  return (
    <section
      aria-label="Practical checklist"
      className="not-prose mt-12 rounded-3xl border border-border bg-card p-6 sm:p-8 shadow-sm"
    >
      <p className="text-base font-semibold text-foreground mb-5">
        Practical checklist
      </p>
      <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
        {items.map((it, i) => (
          <li key={i} className="flex gap-3 items-start">
            <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary">
              <Check className="h-3.5 w-3.5" />
            </span>
            <span className="text-body text-foreground/90 leading-snug">{it}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}